import React from 'react';
import { FDBox, FDStack } from '@facet-wealth/design';
import { MemberDemographics } from 'Views/Page/Content/Templates/MemberDashboard/content/MemberDemographics';
import { MemberDashboardTabs } from 'Views/Page/Content/Templates/MemberDashboard/content/MemberDashboardTabs';
import useBoneBackgroundColor from 'Hooks/useBoneBackgroundColor';

const MemberDashboard = () => {
  useBoneBackgroundColor();
  return (
    <FDBox paddingX={3} margin={2}>
      <FDStack direction={'column'} spacing={2}>
        <MemberDemographics />
        <MemberDashboardTabs />
      </FDStack>
    </FDBox>
  );
};

MemberDashboard.defaultProps = {};

MemberDashboard.propTypes = {};

export { MemberDashboard };
